import { NEDGLOBE_CUSTOM_REFCODES } from '../../constants';
import i18n from '../../i18n';

export function getRefcodesByName(name) {
    const entries = NEDGLOBE_CUSTOM_REFCODES.ENTRIES[name] || null;
    let translatedEntries = [];
    // value contains array of items
    for (const item of entries) {
        // skip translation of operators: <, <=, >, etc.
        if (item.description.length > 2) {
            // replace description by translated value
            translatedEntries.push({ code: item.code, description: i18n.t(item.description) });
        } else {
            translatedEntries.push(item);
        }
    }
    return translatedEntries;
}

/**
 * Retrieve a list of referenceCodes based on name/language combination
 * Used for filling drop-down lists
 * @param {any} _name  ref-code name
 * @param {any} _language ref-code language
 * @returns {Promise} promise object
 */
export function getRefCodes(_name) {
    return new Promise((resolve, reject) => {
        // get all refcodes for this name
        const refcodes = getRefcodesByName(_name);
        if (refcodes && refcodes.length > 0) {
            resolve({ data: refcodes });
        } else {
            console.log(`getRefCodes not found: ${_name}`);
            resolve({ data: [] });
        }
    });
}
